import { Box, Button, Typography, IconButton, useTheme, Divider, Paper, Fab } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton';
import SelectInputs from './select-inputs';
import DateTimeSelector from './date-time-select';

import { tokens } from '../../../../theme';

import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectApp } from '../../../../store/plantio/plantio.selector';

import { generalDataArr, generalProjecs, generalTypesProds, generalProds, generalAppsGeneral, getInsumosList, farmDictCOde, armazemDictCode } from './helper';

import ListProducts from './list-products';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';

import toast from "react-hot-toast";
import { selectIsAdminUser } from '../../../../store/user/user.selector';

import djangoApi from '../../../../utils/axios/axios.utils';

import Swal from "sweetalert2";
import OpenApsAllprodsPage from './list-prods-open-apss-all';

import html2canvas from "html2canvas";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";


import { ref, uploadString, getDownloadURL } from "firebase/storage";
import { storage } from "../../../../utils/firebase/firebase";




const ProdutosConsolidados = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isAdminUser = useSelector(selectIsAdminUser);

    const openApp = useSelector(selectApp);


    const [onlyDates, setOnlyDates] = useState([]);
    const [onlyProjetos, setOnlyProjetos] = useState([]);
    const [onlyTypes, setOnlyTypes] = useState([]);
    const [onlyProdutcts, setOnlyProdutcts] = useState([]);
    const [onlyApps, setOnlyApps] = useState([]);
    const [showDateTime, setShowDateTime] = useState(null);

    const [selectedData, setSelectedData] = useState({});
    const [observations, setObservations] = useState("");

    const [productsArr, setProductsArr] = useState([]);
    const [prodcutsToProtheus, setprodcutsToProtheus] = useState([]);

    const [stOpened, setStOpened] = useState(null);
    const [filteredData, setFilteredData] = useState([]);


    const [isLoadingBtn, setIsLoadingBtn] = useState(false);

    const captureRef = useRef(null);
    const lastAutoTipoApRef = useRef("");


    // useEffect(() => {
    //     console.log('selectedData', selectedData);
    // }, [selectedData]);


    const handleClear = () => {
        console.log('clear')
        setSelectedData({})
        setStOpened(null)
        setObservations("")
        setFilteredData([])
    }

    const savePreStImageToFirebase = async ({ dataUrl, stNumber }) => {
        const safeStNumber = stNumber?.toString().trim();

        if (!safeStNumber) {
            throw new Error("Número da Pré ST não informado para salvar imagem.");
        }

        const fileName = `pre_st_${safeStNumber}.png`;
        const path = `pre_st/${safeStNumber}/${fileName}`;

        const storageRef = ref(storage, path);

        await uploadString(storageRef, dataUrl, "data_url", {
            contentType: "image/png",
            customMetadata: {
                stNumber: safeStNumber,
                createdFrom: "handlerStProtheus",
            },
        });

        const downloadUrl = await getDownloadURL(storageRef);

        console.log("✅ Imagem Pré ST salva no Firebase:", {
            stNumber: safeStNumber,
            fileName,
            path,
            downloadUrl,
        });

        return {
            stNumber: safeStNumber,
            fileName,
            path,
            downloadUrl,
        };
    };

    const handleCapture = async (stNumberFromParam, options = {}) => {
        const element = captureRef.current;
        if (!element) return;

        const { saveToFirebase = true } = options;

        // Usa o número vindo por parâmetro se existir; se não, cai pro estado
        const stNumber = stNumberFromParam ?? stOpened;

        try {
            const canvas = await html2canvas(element, {
                useCORS: true,
                scale: 2,
            });

            const dataUrl = canvas.toDataURL("image/png");

            // 1. Mantém o download exatamente como hoje
            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = `pre_st_${stNumber?.toString().trim() || "gerada"}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            toast.success(`Captura de tela gerada`, {
                position: "top-center",
                duration: 5000,
            })
            // 2. Salva no Firebase "por trás dos panos"
            // Não usa await aqui para não travar o fluxo visual do usuário
            if (saveToFirebase) {
                savePreStImageToFirebase({
                    dataUrl,
                    stNumber,
                }).catch((err) => {
                    console.error("Erro ao salvar imagem Pré ST no Firebase:", err);

                    toast.error("Imagem baixada, mas não foi salva no Firebase.", {
                        position: "top-center",
                        duration: 5000,
                    });
                });
            }
        } catch (err) {
            console.error("Erro ao gerar imagem:", err);
            alert("Não foi possível gerar a imagem.");
        }
    };


    useEffect(() => {
        if (openApp.length > 0) {

            const getDates = generalDataArr(openApp)
            const getProjetos = generalProjecs(openApp)
            const getTypes = generalTypesProds(openApp)
            const getProds = generalProds(openApp)
            const getApps = generalAppsGeneral(openApp)
            const getProducts = getInsumosList(openApp)


            if (getDates.length > 0) {
                setOnlyDates(getDates);
                setOnlyProjetos(getProjetos);
                setOnlyTypes(getTypes)
                setOnlyProdutcts(getProds)
                setOnlyApps(getApps)
                setProductsArr([])
                setProductsArr(getProducts)
            }
        }
    }, [openApp]);

    useEffect(() => {
        const selectedAps = selectedData?.Ap || [];
        const apSignature = selectedAps.join("||");

        const tipoOperacao = onlyTypes.find((type) => {
            const normalized = String(type || "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .trim();

            return normalized === "operacao";
        });

        if (!tipoOperacao) return;

        // Se não tem AP selecionada, libera para aplicar novamente na próxima seleção
        if (selectedAps.length === 0) {
            lastAutoTipoApRef.current = "";
            return;
        }

        // Só aplica automaticamente quando a AP mudar
        if (lastAutoTipoApRef.current === apSignature) return;

        lastAutoTipoApRef.current = apSignature;

        setSelectedData((prev) => {
            const currentTipos = Array.isArray(prev?.Tipo) ? prev.Tipo : [];

            if (currentTipos.includes(tipoOperacao)) {
                return prev;
            }

            return {
                ...prev,
                Tipo: [tipoOperacao],
            };
        });
    }, [selectedData?.Ap, onlyTypes]);

    const handlerStProtheus = async () => {
        const projetoSelecionado = selectedData?.Projeto?.[0];
        const dataSelecionada = selectedData?.Data?.[0];
        const apSelecionada = selectedData?.Ap?.[0];
        const tipoSelecionado = selectedData?.Tipo?.[0];
        const insumoSelecionado = selectedData?.Insumo?.[0];

        const openAppsFiltradas = (openApp || []).filter((app) => {
            // console.log('aaapppppsss here', app)
            const farmName = app?.plantations?.[0]?.plantation?.farm_name || "";
            const appDate = app?.date || "";
            const appCode = app?.code || "";

            const appLabel = `${farmName?.replace('Fazenda ', '')} - ${appCode} | ${appDate}`;

            const matchProjeto = !projetoSelecionado || farmName === projetoSelecionado;
            const matchData = !dataSelecionada || appDate === dataSelecionada;
            const matchAp = !apSelecionada || appLabel === apSelecionada;

            const matchTipo =
                !tipoSelecionado ||
                (app?.inputs || []).some(
                    (input) => input?.input?.input_type_name === tipoSelecionado
                );

            const matchInsumo =
                !insumoSelecionado ||
                (app?.inputs || []).some(
                    (input) => input?.input?.name === insumoSelecionado
                );

            return matchProjeto && matchData && matchAp && matchTipo && matchInsumo;
        });

        const harvestIdsFiltradas = [
            ...new Set(
                openAppsFiltradas
                    .flatMap((app) => app?.plantations || [])
                    .map((item) => item?.plantation?.harvest?.id)
                    .filter(Boolean)
            )
        ];

        const culturasFiltradas = [
            ...new Set(
                openAppsFiltradas
                    .flatMap((app) => app?.plantations || [])
                    .flatMap((item) => [
                        item?.plantation?.culture_name,
                        item?.plantation?.planned_culture_name,
                    ])
                    .filter(Boolean)
            )
        ];

        const observacaoCulturas = culturasFiltradas.length
            ? `Culturas: ${culturasFiltradas.join(", ")}`
            : "";

        const observacaoFinal = [
            observations?.trim(),
            observacaoCulturas,
        ].filter(Boolean).join("\n");

        setObservations(observacaoFinal);


        const getCode = farmDictCOde.find((data) => data.projeto === selectedData.Projeto[0]).code;
        const getArmazenCode = armazemDictCode.find((data) => data.projeto === selectedData.Projeto[0]).code;
        const dataToSend = {
            ...selectedData,
            produtos: prodcutsToProtheus?.filter((prod) => prod.inputType !== "Operação"),
            fazendaDestino: getCode,
            armazemDestino: getArmazenCode,
            observacao: observacaoFinal,
            produtosGeral: filteredData,
            safrasId: harvestIdsFiltradas
        }
        // console.log('dados Selecionados: ', dataToSend,)
        const params = JSON.stringify(dataToSend)
        console.log('data to send protheus: ', params)
        try {
            setIsLoadingBtn(true);

            const res = await djangoApi.post(
                "opensts/open_st_by_protheus/",
                { dados_st: params },
                {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                    },
                }
            );

            console.log("Resposta ao abrir ST:", res);

            if (res.status === 201) {
                const { st_number, sent_by_email } = res.data;

                setStOpened(st_number);

                // Aguarda apenas a renderização do número da Pré-ST.
                // Não depende mais da confirmação do Swal.
                setTimeout(() => {
                    handleCapture(st_number, {
                        saveToFirebase: true,
                    }).catch((captureError) => {
                        console.error(
                            "Erro ao capturar a tela após abrir ST:",
                            captureError
                        );
                    });
                }, 1000);

                if (sent_by_email === "Não") {
                    console.warn("ST aberta, mas o e-mail não foi enviado:", st_number);

                    Swal.fire({
                        title: "Atenção!",
                        html: `
            <b>Pré-ST aberta com sucesso: ${st_number}</b>
            <br />
            O e-mail não foi enviado.
        `,
                        icon: "warning",
                        showCloseButton: true,
                    });
                } else {
                    console.log("ST aberta com sucesso:", st_number);

                    Swal.fire({
                        title: "Feito!",
                        html: `
            <b>Pré-ST aberta com sucesso: ${st_number}</b>
            <br />
            Enviada por e-mail: ${sent_by_email}
        `,
                        icon: "success",
                    });
                }
                
                return;
            }

            Swal.fire({
                title: "Resposta inesperada",
                text: `O servidor respondeu com o status ${res.status}.`,
                icon: "warning",
                showCloseButton: true,
            });
        } catch (err) {
            const status = err?.response?.status;
            const responseData = err?.response?.data;

            console.error("Erro completo ao abrir ST:", err);
            console.error("Resposta do servidor:", {
                status,
                data: responseData,
                headers: err?.response?.headers,
            });

            if (!err?.response) {
                console.error("Requisição sem resposta do servidor:", err?.request);
            }

            const errorTitle =
                responseData?.msg ||
                (status === 504
                    ? "Timeout ao abrir a ST"
                    : status === 502
                        ? "Erro de comunicação com o Protheus"
                        : "Erro ao abrir a ST");

            const errorMessage =
                responseData?.error ||
                responseData?.detail ||
                (status
                    ? `O servidor respondeu com o status ${status}.`
                    : "O servidor não respondeu. Verifique a conexão ou os logs do Railway.");

            await Swal.fire({
                title: errorTitle,
                text: errorMessage,
                icon: "error",
                showCloseButton: true,
            });

            toast.error(errorMessage, {
                position: "top-center",
                duration: 8000,
            });
        } finally {
            console.log("Finalizando abertura da ST");
            setIsLoadingBtn(false);
        }
    }

    useEffect(() => {
        const getCurrentDateTime = () => {
            const now = new Date();
            const pad = (num) => num.toString().padStart(2, '0');
            const day = pad(now.getDate());
            const month = pad(now.getMonth() + 1); // Months are zero-based
            // const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
            const year = now.getFullYear().toString(); // Get last 2 digits of year
            const hours = pad(now.getHours());
            const minutes = pad(now.getMinutes());

            return `${day}/${month}/${year} - ${hours}:${minutes}`;
        };
        if (selectedData) {
            setShowDateTime(getCurrentDateTime());
        }
    }, [selectedData]);

    return (
        <Box
            width={"100%"}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(6, 200px) 100px 20px',
                    columnGap: '20px',
                    alignItems: 'center',
                }}
            >
                <SelectInputs label="Projeto" inputsArr={onlyProjetos} setSelectedData={setSelectedData} selectedData={selectedData} />
                <SelectInputs label="Data" inputsArr={onlyDates} setSelectedData={setSelectedData} selectedData={selectedData} />
                <SelectInputs label="Ap" inputsArr={onlyApps} setSelectedData={setSelectedData} selectedData={selectedData} />
                <SelectInputs label="Tipo" inputsArr={onlyTypes} setSelectedData={setSelectedData} selectedData={selectedData} />
                <SelectInputs label="Insumo" inputsArr={onlyProdutcts} setSelectedData={setSelectedData} selectedData={selectedData} />
                <DateTimeSelector label="DateTime" setSelectedData={setSelectedData} selectedData={selectedData} />
                {
                    Object.keys(selectedData).length > 0 && isAdminUser &&
                    <>

                        <Box
                            sx={{
                                justifySelf: 'center',
                            }}
                        >
                            <LoadingButton
                                variant="contained"
                                color="success"
                                onClick={handlerStProtheus}
                                disabled={stOpened && stOpened !== 0}
                                loading={isLoadingBtn}
                            >Gerar St</LoadingButton>
                        </Box>
                        <Fab
                            color="success"
                            onClick={() => handleCapture()} // usa o stOpened atual
                            aria-label="Capturar imagem"
                            sx={{
                                position: "fixed",
                                bottom: 24,
                                right: 28,
                                boxShadow: 4,
                            }}
                        >
                            <PhotoCameraIcon />
                        </Fab>
                        <Box
                            sx={{
                                justifySelf: 'center',
                            }}
                        >
                            <IconButton aria-label="delete" onClick={handleClear} color="error">
                                <CancelPresentationIcon />
                            </IconButton>
                        </Box>
                    </>
                }
            </Box>
            {
                Object.keys(selectedData).length > 0 &&
                <Box>
                    <Box
                        ref={captureRef}
                        sx={{
                            display: 'inline-block',
                            paddingRight: '20px'
                        }}
                    >
                        <Box
                            component={stOpened && Paper}
                            elevation={stOpened && 8}
                            sx={{
                                paddingLeft: '20px',
                                marginTop: '5px',
                                marginRight: '-10px',
                                paddingTop: 1
                            }}
                        >
                            <Typography sx={{ fontSize: '12px' }} color={colors.textColor[100]}>{showDateTime}</Typography>
                            {
                                stOpened && stOpened !== 0 &&
                                <Typography sx={{ marginLeft: '-20px', fontWeight: '600', fontSize: '16px', marginTop: '0px', backgroundColor: 'blue', padding: '0px 40px 0px 20px', }} color={colors.textColor[200]}>Pré ST:
                                    <span style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '10px', marginLeft: '10px', }} color={colors.textColor[100]}>{stOpened}</span>
                                </Typography>
                            }
                            {stOpened && stOpened === 0 &&
                                <Typography sx={{ marginLeft: '-30px', fontWeight: '600', fontSize: '16px', marginTop: '0px', backgroundColor: 'red', padding: '0px 40px 0px 30px', }} color={colors.textColor[200]}>Erro ao abrir Pré ST
                                </Typography>

                            }
                        </Box>
                        <ListProducts selectedData={selectedData} productsArr={productsArr} setprodcutsToProtheus={setprodcutsToProtheus} setObservations={setObservations} observations={observations} />
                    </Box>
                    {
                        selectedData &&
                        <>
                            <Divider />
                            <Box
                                sx={{
                                    paddingLeft: '20px',
                                    marginTop: '5px',
                                    marginRight: '-10px',
                                    marginBottom: '40px'
                                }}
                            >
                                <OpenApsAllprodsPage data={openApp} selectedData={selectedData} setFilteredData={setFilteredData} filteredData={filteredData} />
                            </Box>
                        </>
                    }
                </Box>
            }

        </Box>
    );
}

export default ProdutosConsolidados;